import React from 'react';

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Mixpanel } from '../../redux/Mixpanel';

import {
    UncontrolledTooltip,
    FormGroup,
    Container,
} from 'reactstrap';

 import { formatDate } from '../../utils';

 import store from '../../redux/store';
 import {
    fetchOptions,
    showLoading,
    sendPaymentReceipt,
    downloadInvoiceOrReceipt,
    downloadTransactions,
    deletePayments,
    showCustomMessage,
    fetchCurrency
 } from '../../redux/actions';

 import {
    fetchPropertiesUnitsTenants
 } from '../../redux/middleware';


import { colorTheme } from '../../utils/constants';
import { Card } from '@tremor/react';
import { IonButton, IonButtons, IonCheckbox, IonContent, IonHeader, IonIcon, IonList, IonModal, IonRow, IonTitle, IonToolbar } from '@ionic/react';
import PaymentTableListItems from './paymentsTableListItems';
import _ from 'lodash';
import { send } from 'ionicons/icons';
import AssignTenantForm from '../../pages/Forms/AssignPaymentToTenantForm';
import { ReallocateTenantPaymentForm } from '../../pages/Forms';

 const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        tenants: state.tenants,
        options: state.options,
        user: state.user,
        currency: state.currency
    };
}

const mapDispatchToProps = {
    fetchOptions,
    showLoading,
    sendPaymentReceipt,
    downloadInvoiceOrReceipt,
    downloadTransactions,
    showCustomMessage,
    deletePayments,
    fetchCurrency
};

const PAGE_HOME = "homepage";
const PAGE_PAYMENT_FORM = "paymentForm";
const PAGE_REALLOCATE_PAYMENT_FORM = "reallocatePaymentForm";
const PAGE_ASSIGN_TENANT = "assignTenant";


class PaymentsTable extends React.Component{
    constructor(props){
        super(props);
        this.assignTenantRef = React.createRef();
        this.reallocatePaymentRef = React.createRef();
        this.handleCloseAssignTenantModal = this.handleCloseAssignTenantModal.bind(this);
        this.state = {
            payments: [],
            selected: [],
            tenantDetails: null,
            paymentId: "",
            unassigned : false,
            allPaymentsSelected: -1,
            page: PAGE_HOME,
            userAllPerms: this.props.userAllPerms
        }
    }

    async fetchInitialData(){
        if(_.isEmpty(this.props.properties)){
            await store.dispatch(fetchPropertiesUnitsTenants);
        }
        await Promise.all([
            (
                async () => {
                    if(_.isEmpty(this.props.options)){
                        this.props.showLoading(true);
                        await this.props.fetchOptions();
                    }
                }
            )(),
            async () => {
                if(_.isEmpty(this.props.currency)){
                    this.props.showLoading(true);
                    await this.props.fetchCurrency();
                }
            }
        ]);
    }

    formatPayments(payments){
        return payments.map(
            payment => ({
                formattedDate: formatDate(payment.created),
                tenantName: payment,
                propertyUnitName: payment.tenant,
                action: payment,
                ...payment
            })
        )
    }

    async handleBulkSendReceipts(){
        if(!this.state.userAllPerms.message){
            this.props.showCustomMessage("","You do not have permission to send receipts.");
            return;
        }
        if(this.state.selected.length == 0){
            this.props.showCustomMessage("","Please select a payment.");
        }else{
            this.props.showLoading(true);
            await this.props.sendPaymentReceipt({paymentIds: this.state.selected});
            Mixpanel.track("Payments tab: Bulk actions send receipt");
        }
    }

    async componentDidMount(){
        await this.fetchInitialData();
        this.updatePayments();
    }

    updatePayments(){
        const payments = this.formatPayments(this.props.payments);
        this.setState({
            payments,
        });
    }

    handleCloseAssignTenantModal(){
        this.setState({page: PAGE_HOME, paymentId: "" });
    }

    async handleSelectPaymentAction(action, paymentId){
        if(action === 'sendReceipt'){
            this.props.showLoading(true);
            this.props.sendPaymentReceipt({paymentIds: [paymentId]});
            Mixpanel.track("Payments tab: quick actions send receipt");
        } else if(action === 'downloadReceipt'){
            this.props.showLoading(true);
            this.props.downloadInvoiceOrReceipt('receipt', paymentId);
        } else if(action === 'reallocate'){
            this.setState({paymentId, page: PAGE_REALLOCATE_PAYMENT_FORM});
        }
    }

    handleSelect(paymentId, isSelected){
        if (isSelected) {
            this.setState(prevState => ({ selected: [...prevState.selected, paymentId] }))
        } else {
            this.setState({
                selected: this.state.selected.filter(itemId => itemId !== paymentId), allPaymentsSelected: -1
            })
        }
    }

    handleSelectAll(isSelected, rows){
        if (isSelected) {
            this.setState({ selected: _.map(rows, 'paymentId'), allPaymentsSelected: 1 })
        } else {
            this.setState({ selected: [], allPaymentsSelected: 0 });
        }
    }

    onClickAssignTenant(paymentId, amount){
        Mixpanel.track("Payments tab: Assign payment to tenant button");
        this.setState({ paymentId, page: PAGE_ASSIGN_TENANT, amount });
    }

    onClickReallocatePayment(event){
        event.preventDefault()
        Mixpanel.track("Payments tab: Reallocate payment to tenant button");
        let paymentId = event.target.value;
        this.setState({paymentId});
        this.reallocatePaymentRef.current.click();
    }

    onSuccessAssignTenant(propertyId, tenantDetails){
        let newPayment;
        let payments = this.state.payments.map(payment => {
            newPayment = { ...payment};
            if(this.state.paymentId == payment.paymentId){
                newPayment = {
                    ...newPayment,
                    tenantDetails: tenantDetails,
                    tenant: tenantDetails,
                    propertyUnitName: tenantDetails
                }
                newPayment["tenantName"] = newPayment;
                newPayment["action"] = newPayment;
            }
            return newPayment
        });
        this.setState({payments});
    }

    renderAssignTenantModal(){
        return (
            <IonModal isOpen={this.state.page === PAGE_ASSIGN_TENANT} onDidDismiss={this.handleCloseAssignTenantModal}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Assign Payment</IonTitle>
                        <IonButtons slot="end">
                            <IonButton id='closeAssignTenantForm' onClick={this.handleCloseAssignTenantModal}>
                                Close
                            </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                <AssignTenantForm
                    dataName={"tenants"}
                    paymentId={this.state.paymentId}
                    amount={this.state.amount}
                    onSuccessCallback={this.onSuccessAssignTenant.bind(this)}
                    unassignedFilter={this.state.unassigned}/>
            </IonContent>
            </IonModal>);
    }

    renderReallocatePaymentForm(){
        return (
            <IonModal isOpen={this.state.page === PAGE_REALLOCATE_PAYMENT_FORM} onDidDismiss={this.handleCloseAssignTenantModal}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Re-allocate Payment</IonTitle>
                        <IonButtons slot="end">
                        <IonButton onClick={this.handleCloseAssignTenantModal}>
                            Close
                        </IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                <ReallocateTenantPaymentForm
                    dataName={"tenants"}
                    paymentId={this.state.paymentId}
                    unassignedFilter={this.state.unassigned}/>
                </IonContent>
            </IonModal>
        );
    }

    renderHome(){
        let disabledBulkActions = this.state.selected.length == 0;
        return (
            <div>
                <IonHeader>
                    <FormGroup row className="d-flex justify-content-start my-5">
                        {disabledBulkActions && (<UncontrolledTooltip placement="top" target="sendPaymentsBtn">
                        Please first select a payment
                        </UncontrolledTooltip>)}
                        <IonButton
                            id="sendPaymentsBtn"
                            style={{borderColor: colorTheme["primary"]["700"] }}
                            onClick={this.handleBulkSendReceipts.bind(this)}
                            >
                                <IonIcon icon={send}></IonIcon>
                            Send Receipt(s)
                        </IonButton>
                    </FormGroup>
                </IonHeader>

                <IonRow className='my-3'>
                    <IonCheckbox
                        checked={this.state.allPaymentsSelected == 1}
                        className='mr-2'
                        onIonChange={(e) => this.handleSelectAll(e.target.checked, this.state.payments)}
                    /> Select all
                </IonRow>

                <Card style={{ margin: "0", padding: "0" }}>
                    <IonList id='ion-list-descriptions' style={{ margin: "0", padding: "0" }}>
                        {this.state.payments.map((payment, index) => {
                            let paymentId = "";
                            let tenantName = "";
                            let date = "";
                            let status = "";
                            let amount = "";
                            let currency = this.props.currency.customerCurrency || "";
                            let message = "";
                            if(payment){
                                paymentId = payment.paymentId || "";
                                if (payment.tenant) {
                                    tenantName = payment.tenant.firstName ? payment.tenant.firstName : "";
                                    if (payment.tenant.lastName) {
                                        tenantName += " " + payment.tenant.lastName;
                                    }
                                }
                                date = payment.formattedDate? payment.formattedDate : null;
                                status = payment.status || "";
                                amount = payment.amount || "";
                                message = payment.message || "";
                            }
                            return(
                                <PaymentTableListItems
                                    index={index}
                                    paymentId={paymentId}
                                    tenantName={tenantName}
                                    date={date}
                                    status={status}
                                    amount={amount}
                                    currency={currency}
                                    key={paymentId}
                                    message={message}
                                    options={this.props.options}
                                    handlePaymentAction={this.handleSelectPaymentAction.bind(this)}
                                    handleSelect={this.handleSelect.bind(this)}
                                    onClickAssignTenant={this.onClickAssignTenant.bind(this)}
                                    allPaymentsSelected={this.state.allPaymentsSelected}
                                    userAllPerms={this.state.userAllPerms}
                                />
                            )
                        })}
                    </IonList>
                </Card>
            </div>
        );
    }

    render(){
        return (
            <div>
                {this.state.page === PAGE_ASSIGN_TENANT && this.renderAssignTenantModal()}
                {this.state.page === PAGE_REALLOCATE_PAYMENT_FORM && this.renderReallocatePaymentForm()}
                {this.state.page === PAGE_HOME && this.renderHome()}
            </div>
        )
    }
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentsTable));